@let view = data();

<ui-image uiPageBlockImpression [data]="view.image"></ui-image>
<div class="slide-content">
  @if (view.headline) {
    <h1>{{ view.headline }}</h1>
  }
  @if (view.text) {
    <div [innerHTML]="view.text" class="text-py"></div>
  }
  <div class="hero-buttons">
    @if (view.link && view.link.href) {
      <a uiPageBlockLinkClick uiContentLink [link]="view.link" mat-flat-button>
        {{ view.link.label }}
      </a>
    }

    @if (view.secondaryLink && view.secondaryLink.href) {
      <a uiPageBlockLinkClick uiContentLink [link]="view.secondaryLink" mat-stroked-button class="secondary-button">
        {{ view.secondaryLink.label }}
      </a>
    }
  </div>
</div>
